module.exports = __webpack_public_path__ + "img/espresso.1f77e3f3.png";